import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import axios from 'axios'
import Titulo from '../comum/Titulo'
import { buscarFilaVendas, buscarPedidoSincronizado, salvarMapeamentoPedidoSync, removerVendaDaFila } from '../../util/offlineStorage'
import { URL } from '../../util/ambienteActions'

class PainelListarVendasOffline extends React.Component {
  constructor(props) {
    super(props)
    this.state = { vendas: [], carregando: true }
  }

  componentDidMount() {
    this.carregarVendas()
    this.interval = setInterval(() => this.carregarVendas(), 10000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  async carregarVendas() {
    try {
      const fila = await buscarFilaVendas() || []
      let vendasServidor = []

      if (navigator.onLine && this.props.empresaSelecionada) {
        try {
          const resp = await axios.get(`${URL}/reserva/venda-offline/empresa/${this.props.empresaSelecionada.id}`)
          vendasServidor = resp.data || []
        } catch (e) { /* offline ou erro de rede — usa apenas dados locais */ }
      }

      const mapaServidor = {}
      vendasServidor.forEach(v => { mapaServidor[v.idChaveOffline] = v })

      const vendasLocais = await Promise.all(fila.map(async v => {
        const ds = mapaServidor[v.idChaveOffline] || null
        if (ds && ds.status === 'RESOLVIDO' && ds.pedidoId && !buscarPedidoSincronizado(v.idChaveOffline)) {
          salvarMapeamentoPedidoSync(v.idChaveOffline, ds.pedidoId)
          await removerVendaDaFila(v.idChaveOffline)
        }
        return {
          ...v,
          pedidoSincronizado: buscarPedidoSincronizado(v.idChaveOffline),
          dadosServidor: ds
        }
      }))

      const chavesLocais = new Set(fila.map(v => v.idChaveOffline))
      const vendasSoServidor = vendasServidor
        .filter(v => !chavesLocais.has(v.idChaveOffline))
        .map(v => ({
          idChaveOffline: v.idChaveOffline,
          dadosServidor: v,
          pedidoSincronizado: v.pedidoId || null
        }))

      this.setState({ vendas: [...vendasLocais, ...vendasSoServidor], carregando: false })
    } catch (e) {
      this.setState({ vendas: [], carregando: false })
    }
  }

  calcularValor(venda) {
    if (!venda.formasPagamentoDto || !venda.formasPagamentoDto.length) return 0
    return venda.formasPagamentoDto.reduce((acc, fp) => acc + Number(fp.valor || 0), 0)
  }

  renderStatus(venda) {
    if (venda.pedidoSincronizado) {
      return (
        <span className="vx-gp-badge vx-gp-badge--aprovado">
          Sincronizado #{venda.pedidoSincronizado}
        </span>
      )
    }
    if (venda.dadosServidor) {
      const s = venda.dadosServidor.status
      if (s === 'RESOLVIDO') {
        return (
          <span className="vx-gp-badge vx-gp-badge--aprovado">
            Sincronizado #{venda.dadosServidor.pedidoId}
          </span>
        )
      }
      if (s === 'ERRO_SYNC') {
        return (
          <span className="vx-gp-badge vx-gp-badge--cancelado" title={venda.dadosServidor.erroMensagem}>
            Erro: {venda.dadosServidor.erroMensagem}
          </span>
        )
      }
      if (s === 'PROCESSANDO' || s === 'PENDENTE') {
        return <span className="vx-gp-badge vx-gp-badge--processando">Em processamento...</span>
      }
    }
    if (venda.erroSync) {
      return (
        <span className="vx-gp-badge vx-gp-badge--cancelado" title={venda.erroSync}>
          Erro: {venda.erroSync}
        </span>
      )
    }
    if (venda.statusServidor === 'PROCESSANDO') {
      return (
        <span className="vx-gp-badge vx-gp-badge--processando">
          Em processamento...
        </span>
      )
    }
    return <span className="vx-gp-badge vx-gp-badge--pendente">Pendente</span>
  }

  renderVenda(venda) {
    const dv  = venda.dadosViagem || {}
    const ida = dv.ida || {}
    const ds  = venda.dadosServidor || {}

    const descRota = dv.origemNome
      ? `${dv.origemNome} → ${dv.destinoNome || '-'}`
      : (ds.descricaoRota || '-')

    const dataViagem = ida.dataPartida
      ? `${ida.dataPartida} ${ida.horaPartida || ''}`.trim()
      : (ds.dataViagem || '-')

    const primeiroPassageiro = (venda.reservas && venda.reservas[0] && venda.reservas[0].passageiroDto
      ? venda.reservas[0].passageiroDto.nome
      : null) || ds.nomePassageiro || '-'

    const qtdPassageiros = venda.reservas ? venda.reservas.length : 0

    const valor = venda.formasPagamentoDto && venda.formasPagamentoDto.length
      ? this.calcularValor(venda)
      : (ds.valorTotal || 0)

    const ref = (venda.idChaveOffline || '').substring(0, 8)

    return (
      <div key={venda.idChaveOffline} className="vx-vo-row">
        <div className="vx-vo-cell" data-label="Ref.">
          <span className="vx-vo-ref">{ref}...</span>
        </div>
        <div className="vx-vo-cell" data-label="Rota">
          {descRota}
        </div>
        <div className="vx-vo-cell" data-label="Data">
          {dataViagem}
        </div>
        <div className="vx-vo-cell" data-label="Passageiro">
          {primeiroPassageiro}
          {qtdPassageiros > 1 && <span className="vx-vo-badge-count"> +{qtdPassageiros - 1}</span>}
        </div>
        <div className="vx-vo-cell" data-label="Valor">
          {Number(valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </div>
        <div className="vx-vo-cell" data-label="Status">
          {this.renderStatus(venda)}
        </div>
        <div className="vx-vo-cell" data-label="Ações">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => this.props.history.push(`/recibo-offline?chave=${venda.idChaveOffline}`)}
          >
            Ver recibo
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { vendas, carregando } = this.state

    return (
      <div className="row internas">
        <Titulo texto="Vendas Offline" />
        <div className="col-12">
          {carregando ? (
            <div className="text-center p-4">Carregando...</div>
          ) : vendas.length === 0 ? (
            <div className="alert alert-info text-center">
              Nenhuma venda offline registrada.
            </div>
          ) : (
            <div className="vx-vo-table">
              <div className="vx-vo-header">
                <div className="vx-vo-cell">Ref.</div>
                <div className="vx-vo-cell">Rota</div>
                <div className="vx-vo-cell">Data</div>
                <div className="vx-vo-cell">Passageiro</div>
                <div className="vx-vo-cell">Valor</div>
                <div className="vx-vo-cell">Status</div>
                <div className="vx-vo-cell">Ações</div>
              </div>
              {vendas.map(v => this.renderVenda(v))}
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada
})

export default withRouter(connect(mapStateToProps)(PainelListarVendasOffline))
